let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page039_game10/img/bcg2.jpg',
    width: 1430,
    height: 910,
    pos: {
      x: 279,
      y: 138,
    },
  },
  activeArea: {
    width: 50,
    height: 50,
    fontSize: 35,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '3',
      animation: true,
      direction: 'left',
      textObj: {
        text: 'Kliknij w strzałkę rozwijanej listy rozmiaru czcionki.',
      },
      audio: {
        src: 'games/page039_game10/audio/z19s39-3.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 551,
        y: 324,
      },
    },
    {
      id: '4',
      // direction: 'left',
      textObj: {
        text: 'Ustaw rozmiar czcionki na 20.',
      },
      audio: {
        src: 'games/page039_game10/audio/z19s39-4.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 531,
        y: 576,
      },
    },
    {
      id: '5',
      direction: 'left',
      textObj: {
        text: 'Sprawdź, czy zaznaczona jest opcja <i>Przezroczyste tło</i>.',
      },
      audio: {
        src: 'games/page039_game10/audio/z19s39-5.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 903,
        y: 284,
      },
    },
    {
      id: '6',
      // direction: 'left',
      textObj: {
        text: 'Wybierz kolor czcionki.',
      },
      audio: {
        src: 'games/page039_game10/audio/z19s39-6.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1015,
        y: 323,
      },
    },
    {
      id: '7',
      // direction: 'left',
      textObj: {
        text: 'Umieść pole tekstowe w&nbsp;wybranym miejscu metodą <i>złap, przesuń i&nbsp;upuść</i>.',
      },
      audio: {
        src: 'games/page039_game10/audio/z19s39-7.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 821,
        y: 656,
      },
    },
  ],
};
export default elements;
